const firebaseConfig = {
  apiKey: "AIzaSyCGFtuCZqESQq8Rc6uSBT0DyEmeKsKDdyQ",
  authDomain: "ejercicios-lti.firebaseapp.com",
  projectId: "ejercicios-lti",
  storageBucket: "ejercicios-lti.firebasestorage.app",
  messagingSenderId: "353625480301",
  appId: "1:353625480301:web:6b0478b9a0e30d7ed2f364",
  measurementId: "G-QCKWZ2WYJQ"
};

export default firebaseConfig;